import React from 'react';

const Logo = (props) => {
  return <img height="50px" alt="Logo" src="/static/logo.png" {...props} />;
};

export default Logo;
